<template>
<div class="player" v-bind:text-content:prop="audiourl">
    <div class="inner">
        <audio id="player" controls style="display: none; "></audio>
        <div v-bind:class="{playing:playing}" class="buttons">
            <button class="rev pointer" @click="revAudio"><img v-bind:class="{active:playing}"  src="/static/assets/player/rev.png" /></button>
            <button class="play pointer" v-if="!playing" @click="playAudio"><img v-bind:class="{active:!playing}" src="/static/assets/player/play.png" /></button>
            <button class="fwd pointer" v-if="playing" v-bind:class="{playing: playing}" @click="fwdAudio">
              <img v-bind:class="{active:!playing}"  src="/static/assets/player/fwd.png" />
            </button>
        </div>
        <div class="progressbar">
            <div class="indicator"> <img src="/static/assets/player/roter_punkt.png" /></div>
        </div>
    </div>
</div>
</template>
<script>
/* eslint-disable */
var TextFinder = function(options) {

	var t = this;

	// store options
	for (var opt in options) {
		t[opt] = options[opt];
	}

	t.skipTagsRegex = new RegExp('^(' + t.skipTags.join('|') + ')$', 'i');
	t.skipClassesRegex = new RegExp('\b(' + t.skipClasses.join('|') + ')\b', 'i');

}
TextFinder.prototype = {

	foundTagName: 'span',
	foundTagClass: 'aligned-word',

	skipTags: [],
	skipClasses: [],

	root: null,
	currentDepth: -1,
	currentNode: null,

	lastSuccessfulNode: null,
	lastSuccessfulDepth: -1,

	currentText: '',

	reset: function() {
		this.lastSuccessfulNode = null;
		this.lastSuccessfulDepth = -1;
	},

	// public function to start things up
	next: function(text) {

		var t = this;

		t.currentText = text;

		// if we haven't found a node yet, then we need to start over
		if (t.lastSuccessfulNode == null) {
			t.currentNode = t.root.childNodes[0];
			t.currentDepth = 1;
		} else {
			t.currentNode = t.lastSuccessfulNode;
			t.currentDepth = t.lastSuccessfulDepth;
		}

		return t._searchNodes();
	},

	_searchNodes: function() {

		var t = this,
			foundNode = null;



		// spin through nodes until we find the text
		while (t.currentNode && t.currentDepth > 0 && foundNode == null) {

			switch (t.currentNode.nodeType) {

				// for elements, we need to go down to the next level
				case 1: // ELEMENT_NODE
					if (!t.skipTagsRegex.test(t.currentNode.tagName.toLowerCase()) && // is this not a tag we should skip?
						!t.skipClassesRegex.test(t.currentNode.className.toLowerCase()) &&
						t.currentNode.childNodes.length > 0  //  does it have any child nodes
						) {

						t.currentNode = t.currentNode.childNodes[0];
						t.currentDepth++;
						continue;
					}
					break;
				case 3: // TEXT_NODE
				case 4: // CDATA_SECTION_NODE
					foundNode = t._findTextInNode();

					// once we find one the loop will stop
					if (foundNode != null) {

						t.lastSuccessfulNode = foundNode
						t.lastSuccessfulDepth = t.currentDepth;

						// clear out for the next round
						t.currentNode = null;
						t.currentDepth = -1;

						return foundNode;
					}
					break;
			}

			// if we didn't find anything in this node,
			// then go to the next sibling node or back up to the parent
			if (t.currentNode.nextSibling) {
				t.currentNode = t.currentNode.nextSibling;
			} else {

				while (t.currentDepth > 0) {
					t.currentNode = t.currentNode.parentNode;
					t.currentDepth --;
					if (t.currentNode.nextSibling) {
						t.currentNode = t.currentNode.nextSibling;
						break;
					}
				}
			}
		}

		return null;
	},

	_findTextInNode: function() {

		var t = this
			// wordIndex = t.currentNode.data.toLowerCase().indexOf(t.currentText.toLowerCase());
		var wordIndex = t.currentNode.wholeText.toLowerCase().indexOf(t.currentText.toLowerCase())
		// console.log(t, wordIndex)
		if (wordIndex > -1) {

			var targetNode = (t.currentNode.nodeType == 1) ? t.currentNode.firstChild : t.currentNode
			var	wordNode = targetNode.splitText(wordIndex)
			var afterWord = wordNode.splitText(t.currentText.length)
			var beforeWord = targetNode

			var	highlightedWord = wordNode.ownerDocument.createElement(t.foundTagName);
			wordNode.parentNode.replaceChild(highlightedWord, wordNode);
			highlightedWord.setAttribute('class', t.foundTagClass)
			highlightedWord.appendChild(wordNode)

			return highlightedWord;
		} else {

			return null;
		}

	}
};


var AudioAligner = function(target, audio) {

	var t = this;

	// hook up to media
	t.audio = audio;
	t.audio.addEventListener('timeupdate', function() { t.selectWord(); });
	t.audio.addEventListener('seeked', function() { t.selectWord(); });

	// target node where stuff will get loaded

	t.target = target;

	// node finder
	t.textfinder = new TextFinder({root: t.target, skipTags: ['h1','h2','h3'], skipClasses: ['cf','note','v-num']});
}
AudioAligner.prototype = {

	currentWordClassName: 'current-word',

	timingData: null,

	align: function(audioUrl, timingUrl) {
		this.audioUrl = audioUrl;
		this.timingUrl = timingUrl;

		this.loadTimings();

	},

	loadTimings: function() {
		var t = this;

		jQuery.ajax({
			url: t.timingUrl,
			dataType: 'json',
			success: function(json) {

				t.timingData = json.words;

				t.assignTimings();

				// start up MP3
				if (t.audio.setSrc) {
					t.audio.setSrc(t.audioUrl);
				} else {
					t.audio.src = t.audioUrl;
				}
				t.audio.load();
			}
		});
	},

	assignTimings: function() {

		var t = this;

		// go through all the words in the array
		for (var wordIndex=0, wordTotal = t.timingData.length; wordIndex < wordTotal; wordIndex++) {
			var timing = t.timingData[wordIndex],
				word = timing[0];

			// attempt to find this word and create a new node out of it
			var node = t.textfinder.next(word);

			if (node != null) {

				// store node so we can refer to it as the audio plays
				timing[3] = node;

				// since we're in a loop, wrap it in a function
				(function(newTime) {

					// let the user click on the word and play from it
					node.addEventListener('click', function() {
						t.audio.currentTime = newTime;
					}, false);
				})(timing[1]);

			}

		}

		t.textfinder.reset();
	},

	selectWord: function() {
		var t = this;

		if (t.timingData != null) {
			var time = t.audio.currentTime;

			// removing existing current class
			var currents = document.getElementsByClassName(t.currentWordClassName);
			if (currents.length > 0)
				currents[0].className = currents[0].className.replace(t.currentWordClassName, '');

			// find a word with the current time
			for (var i=0, il=t.timingData.length; i<il; i++) {
				var point = t.timingData[i];

				if (time >= point[1] && time <= point[2]) {
					var node = point[3];
					if (!node.className.includes('current-word')) { node.className += ' ' + t.currentWordClassName; }
					node.focus();
					/* SCROLL FUNKTION START  */
					var pos = node.offsetTop // liest den offset des Elements
					// Modulo rechnung - 0 -> 350 >0, 350 = 0. Es wird nie 0, aber wenn der modulo < 30... weiter
					// console.log('player: offsetTop', pos, "modulowert: ", pos % 330 <= 40, pos % 330)
					if (pos <= 40) {
						node.parentNode.parentNode.scrollTop = 0
					}
					else if ((pos >100) && (pos % 330 <= 40)) {
					  // scrollposition setzen...
                      node.parentNode.parentNode.scrollTop = pos
					  console.log(' Scrolltop SETZEN auf: ', pos)
					}
					/* SCROLL FUNKTION ENDE  */
				}
			}
		}
	}
};

export default {
  data () {
    return {
	  who: 'Player',
	  playing: false,
	  paused: false
    }
  },
  watch: {
	  playing: function (newVal, oldVal) {
    	console.log('value changed from ' + oldVal + ' to ' + newVal);
    }
  },
  name: 'Player',
  props: ['audiourl', 'jsonurl','content', 'target'],
  methods: {
    setaudiopos (pos) {
      console.log(pos)
    },
    playAudio () {
            
	  if (typeof window.currentAudio !== 'undefined') {
	    try {window.currentAudio.pause() } catch(e) {}
	// window.currentAudio.currentTime = 0
	  }

  	  window.currentAudio = window.audio

	  window.audio.muted = window.muted
      if (window.audio.playing) {
		window.audio.pause()
		this.$ga.event('geschichten', 'player', 'pause', this.$props.target)
      } else {
		window.audio.play()
		var self = this
		this.$ga.event('geschichten', 'player', 'play', this.$props.target)

        setInterval(function() {
          $('.progressbar .indicator').css('width',(window.audio.currentTime / window.audio.duration * 92) + '%')
	       self.playing = !window.audio.paused
          }, 100)
	  }
	  this.paused = window.audio.paused
	  this.playing = !window.audio.paused
    },
    revAudio () {
      console.log('revAudio started')
      window.audio.load()
      $('.aligned-word').each(function() {
        $( this ).removeClass( 'current-word' )
      })
    },
    fwdAudio () {
      if (window.audio.paused) {
		  window.audio.play()
	  } else {
		  window.audio.pause()
	  }
	  this.paused = window.audio.paused
	  this.playing = !window.audio.paused

    }
  },
  mounted () {
    /* console.log('componentprops:', this.$props)
    window.audio = new Audio(this.$props.audiourl)
    window.audio.play()
    window.zaubergeschichten = this
    window.zginterval = setInterval(function (e) {
    window.zaubergeschichten.setaudiopos(10)
    }, 100)
    if (window.audio.ended()) {
    clearInterval(window.zginterval)
    }
    */
    console.log(this.$props.audiourl, this.$props.jsonurl, this.$props.content, this.$props.target)
    var audio = document.getElementById('player')
    if (!(audio.canPlayType && (audio.canPlayType('audio/mp3') || audio.canPlayType('audio/mpeg')) )) {
    alert('Please use a browser that can play MP3s like Chrome, Safari, IE9');
    }
    // create aligner
    var aligner = new AudioAligner(document.getElementById(this.$props.target), audio);
    // load and align
    aligner.align(this.$props.audiourl, this.$props.jsonurl)
	window.audio = audio
  }
}
</script>

<style lang="css" scoped>
.player { position: absolute; top: 660px; left: 60px; width: 475px; }
.player .inner { position: relative; }
.player .inner .buttons { width: 100%; }
.player .inner .buttons button { border: none; background: transparent; }
.player .inner .progressbar {
    position: relative;
    width: 100%;
    background-color: #e3d4c9;
    height:15px;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 10px;
    top: 93px;
    left: 0px;
}
.player .inner .progressbar .indicator {
    position: relative;
    height: 15px;
    width: 0%; /* width - 0 - 100% für progressbar */
    background-color: #c3ab9a;
    border-radius: 10px;
    max-width: calc(100% - 35px);
}
.player .inner .progressbar .indicator img {
    position: absolute;
    left: 100%;
    top: -4px;
}
/*
.player .inner .buttons .rev {
    position: absolute;
    left: 33px;
}

.player .inner .buttons .play {
    position: absolute;
    left: calc(50% - 42px);
}
.player .inner .buttons .fwd {
    position: absolute;
    right: 62px;
}

.rev, .fwd { opacity: 0.5; }
.playing .rev { opacity: 1.0 !important;  }
.playing .play { opacity: 0.5 !important;  }
.playing .fwd { opacity: 1.0 !important;  }
*/
.player .inner .buttons .rev {
    position: absolute;
    left: 20%;
}

.player .inner .buttons .play {
    position: absolute;
    right: 20%;
}
.player .inner .buttons .fwd {
    position: absolute;
    right: 20%;
}
/* hidden */
.rev, .fwd { opacity: 0.5; }
.playing .rev { opacity: 1.0 !important;  }
.playing .play { opacity: 0.5 !important;  }
.playing .fwd { opacity: 1.0 !important;  }

/* Stories */
.eiswelt .player .inner {
    top: -73px;
}
.escaperoom .player {
    top: 700px;
    left: 120px;
}  
</style>



// WEBPACK FOOTER //
// src/components/Player.vue